module.exports = __webpack_public_path__ + "static/img/photo7.794c6914.jpg";